/**
 * Created by rhett on 2019/4/12.
 */

import React, {Component} from 'react';
import "./LoginPanel.css"
import {Link} from "react-router-dom";

import App from "./App"

export default class LoginPanel extends Component
{

  static _instance = null;

  constructor(props)
  {
    super(props);
    LoginPanel._instance = this;
    this.state = {isShow: false, afterLoginCb: null, loadingLock: false, lastSmsTimestamp: 0, tel: "",code:""};
  }


  static verifyLogin(afterLoginCb)
  {
    App.gw.gwUserVerify((data) =>
    {
      if (data.result == 1)
      {
        //有登录状态
        if (afterLoginCb != null)
          afterLoginCb();
      } else
      {
        //需要登录
        LoginPanel._instance.setState({isShow: true, afterLoginCb, loadingLock: false});
      }
    });
  }

  cancel()
  {
    this.setState({isShow: false, afterLoginCb: null, loadingLock: false});
  }

  componentDidMount()
  {
  }

  render()
  {
    if (!this.state.isShow) return null;
    let {tel, code} = this.state;
    return (
      <div className="centerContainer">

        <div className="blackModal">
        </div>

        <div className="LoginPanel">
          <Link to="./" className="closeBtn" onClick={() =>
          {
            this.cancel()
          }}>X</Link>

          <h1>登 录</h1>
          <input type="text" name="" id="" value={tel} placeholder="请输入手机号" onChange={(e) =>
          {
            this.setState({tel: e.target.value});
          }}/>
          <input type="text" name="" id="" value={code} placeholder="请输入验证码" onChange={(e) =>
          {
            this.setState({code: e.target.value});
          }}/>
          <SendSmsBtn lastSmsTimestamp={this.state.lastSmsTimestamp}
                      enabled={tel.length == 11 }
                      onClick={
                        () =>
                        {
                          let {tel} = this.state;
                          let lastSmsTimestamp = new Date().valueOf();
                          this.setState({lastSmsTimestamp});
                          App.gw.gwSendSms(tel, () =>
                          {
                          });
                        }
                      }/>
          <a href="#" className="btn" onClick={() =>
          {
            let {loadingLock,tel, code, afterLoginCb, isShow} = this.state;
            if ( !tel ||  !code ) {
              alert("必须填写完整");return;}
            if ( loadingLock ) return ;
            this.setState({loadingLock: true});
            App.gw.gwLogin(tel, code, (data) =>
            {
              if (data.uid)
              {
                if (afterLoginCb != null) afterLoginCb();
                this.cancel();
              }
            }, ({error , message})=>{
              alert(message);
              this.setState({loadingLock:false});
            });
          }}>{this.state.loadingLock ? "正在加载...":"确认"}</a>
        </div>


      </div>);
  }


}

const CD_DURATION = 60000;//cd时长60秒
class SendSmsBtn extends Component
{


  constructor(props)
  {
    super(props);
    this.state = {label: ""};

  }

  validate()
  {
    let d = new Date().valueOf();

    let leftTime = CD_DURATION + this.props.lastSmsTimestamp - d;
    if (leftTime <= 0)
    {
      this.setState({label: "获取验证码", cd: false});
    } else
    {
      this.setState({
        label: Math.ceil(leftTime / 1000) + "s后重新获取", cd: true
      });
    }
  }

  componentDidMount()
  {
    this.validate();
    clearInterval(this.itv);
    this.itv = setInterval(this.validate.bind(this), 1000);
  }

  componentWillUnmount()
  {
    clearInterval(this.itv);
  }

  render()
  {
    let {label, cd} = this.state;
    let {enabled} = this.props;
    return (
      <div className="relativePos">
        <a className={"sendSmsBtn " + ((!enabled || cd) ? "cd" : "")} onClick={this.props.onClick}>
          {label}
        </a>

      </div>
    );
  }
}